import { render, staticRenderFns } from "./TOverlay.vue?vue&type=template&id=6a50aabc&scoped=true&"
import script from "./TOverlay.vue?vue&type=script&lang=js&"
export * from "./TOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TOverlay.vue?vue&type=style&index=0&id=6a50aabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50aabc",
  null
  
)

/* custom blocks */
import block0 from "./TOverlay.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports